// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1C4rH","title":"ClientInsurance_title__2hT6f","itemText":"ClientInsurance_itemText__32BuB"};